import React, { useEffect, useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { CRM_LeyendaAuditoria } from "./CRM_LeyendaAuditoria";
import { CRM_LeyendaDepartamento } from "./CRM_LeyendaDepartamento";

// Alta de cliente nuevo — inicia con una fila en blanco lista para capturar
const FORM_VACIO = [{ idequip: "", idsucursal: "" }];

const mapListadoToForm = (listado) =>
  listado.length > 0 ? listado.map((r) => ({ idequip: r.idequip, idsucursal: String(r.idsucursal ?? "") })) : FORM_VACIO;

export const CRM_DetalleEquip = ({ esNuevo, idcliente, equipCliente = [], soloLectura, responsableDepartamento = [] }) => {
  const [editing, setEditing] = useState(esNuevo);
  const [ids, setIds] = useState(mapListadoToForm(equipCliente));
  const [listadoOriginal, setListadoOriginal] = useState(equipCliente);
  const [sucursales, setSucursales] = useState([]);

  // equipCliente llega después del primer render (fetch async en CRM_DetalleScreen) — se sincroniza aquí
  useEffect(() => {
    setListadoOriginal(equipCliente);
    setIds(mapListadoToForm(equipCliente));
  }, [equipCliente]);

  useEffect(() => {
    request
      .get("Sucursales/Listado")
      .then((result) => setSucursales(result || []))
      .catch((error) => Swal.fire("EQUIP", JSON.stringify(error), "error"));
  }, []);

  const fieldClass = () => (editing ? "crm-field-editable" : "crm-field-readonly");

  const handleEditar = () => setEditing(true);
  const handleCancelar = () => {
    setIds(mapListadoToForm(listadoOriginal));
    setEditing(false);
  };

  const handleGuardar = () => {
    const equipos = ids
      .filter((row) => row.idequip && row.idsucursal)
      .map((row) => ({ idequip: row.idequip, idsucursal: Number(row.idsucursal) }));

    if (equipos.length === 0) {
      Swal.fire("EQUIP", "Favor de capturar al menos un ID de sistema con su sucursal", "warning");
      return;
    }

    const body = {
      idcliente: Number(idcliente),
      equip: JSON.stringify({ equip: equipos }),
    };

    request
      .post("ClientesEQUIP/GuardarArrayEquip", body)
      .then(async (result) => {
        await Swal.fire("EQUIP", "Información guardada con éxito", "success");
        setListadoOriginal(result || []);
        setIds(mapListadoToForm(result || []));
        setEditing(false);
      })
      .catch((error) => Swal.fire("EQUIP", JSON.stringify(error), "error"));
  };

  const handleChangeCampo = (idx, campo) => (e) => {
    setIds((prev) => prev.map((row, i) => (i === idx ? { ...row, [campo]: e.target.value } : row)));
  };

  const handleAgregar = () => {
    setIds((prev) => [...prev, { idequip: "", idsucursal: "" }]);
  };

  const handleQuitar = (idx) => {
    const row = ids[idx];

    // Fila que aún no existe en backend — se quita solo del state local
    if (!row.idequip || !listadoOriginal.some((r) => r.idequip === row.idequip)) {
      setIds((prev) => prev.filter((_, i) => i !== idx));
      return;
    }

    Swal.fire({
      title: "¿Eliminar este ID de sistema?",
      text: "Este identificador dejará de estar asociado al cliente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      request
        .get(`ClientesEQUIP/Eliminar?idcliente=${Number(idcliente)}&idequip=${row.idequip}`)
        .then((result) => {
          setListadoOriginal(result || []);
          setIds(mapListadoToForm(result || []));
          setEditing(false);
        })
        .catch((error) => Swal.fire("EQUIP", JSON.stringify(error), "error"));
    });
  };

  return (
    <div id="sec-equip" className="crm-detalle-card" style={{ scrollMarginTop: 170 }}>
      <div className="crm-detalle-card-header crm-detalle-card-header-actions">
        <div>
          <h3>EQUIP</h3>
          <p>Identificadores de sistema asociados al cliente</p>
        </div>
        <div className="crm-detalle-card-header-buttons">
          {editing ? (
            <>
              <button type="button" className="btn-icono-ghost" title="Cancelar" onClick={handleCancelar}>
                <CloseIcon />
              </button>
              <button type="button" className="btn-icono-solido" title="Guardar cambios" onClick={handleGuardar}>
                <CheckIcon />
                <span>Guardar</span>
              </button>
            </>
          ) : (
            !soloLectura && (
            <button type="button" className="btn-icono-ghost btn-editar" title="Editar" onClick={handleEditar}>
              <EditIcon />
              <span>Editar</span>
            </button>
            )
          )}
        </div>
      </div>

      <div className="crm-detalle-card-body">
        {ids.map((row, idx) => (
          <div key={idx} className="crm-detalle-equip-row">
            <div className="crm-field">
              <label>ID de sistema</label>
              <input
                type="text"
                className={`mono ${fieldClass()}`}
                disabled={!editing}
                value={row.idequip}
                onChange={handleChangeCampo(idx, "idequip")}
              />
            </div>
            <div className="crm-field">
              <label>Sucursal</label>
              <select className={fieldClass()} disabled={!editing} value={row.idsucursal} onChange={handleChangeCampo(idx, "idsucursal")}>
                <option value="">Seleccionar</option>
                {sucursales.map((s) => <option key={s.idsucursal} value={String(s.idsucursal)}>{s.sucursal}</option>)}
              </select>
            </div>
            <button type="button" className="btn-quitar-fila" title="Quitar" disabled={!editing} onClick={() => handleQuitar(idx)}>
              <CloseIcon fontSize="small" />
            </button>
          </div>
        ))}

        {editing && (
          <button type="button" className="chip-add-pill" onClick={handleAgregar}>
            + Agregar ID de sistema
          </button>
        )}
      </div>

      <div className="crm-detalle-card-footer">
        <CRM_LeyendaDepartamento responsables={responsableDepartamento} idrel={10} />
        <CRM_LeyendaAuditoria auditoria={listadoOriginal[0]} />
      </div>
    </div>
  );
};
